export * from './colors';

export const SMALL_SCREEN_BREAKPOINT = 1024;

export type Size = 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl';
